import PessoaIdosaIcon from '@/components/icons/IndicadoresAps/eSFeAP/PessoaIdosa.vue'

export default {
  value: 'c6',
  label: 'Pessoa idosa',
  iconType: 'component',
  iconComponent: PessoaIdosaIcon,
  buscaAtiva: {
    a: 'Pessoa ainda sem consulta médica ou de enfermagem nos últimos 12 meses.',
    b: 'Pessoa ainda não tem registro de peso e altura nos  últimos 12 meses.',
    c: 'Pessoa ainda não tem visitas domiciliares realizadas por ACS, com intervalo mínimo de 30 (trinta) dias entre elas, nos últimos 12 meses.',
    d: 'Pessoa ainda não tem dose da vacina influenza, nos últimos 12 meses. Pode informar manualmente acima.',
  },
}
